(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('DocumentEvent', DocumentEvent);

    DocumentEvent.$inject = ['$resource', 'DateUtils'];

    function DocumentEvent ($resource, DateUtils) {
        var resourceUrl =  'api/document-events/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.eventTimestamp = DateUtils.convertDateTimeFromServer(data.eventTimestamp);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
